import React, { useEffect, useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { Accordion, AccordionDetails, AccordionSummary } from '@mui/material';
import { FindLoad, SendPageSave, useGlobalStyles, Images, getSkipCount } from 'utils';
import { AddCircleBlue, Loader, NoItemsYet, SearchAndFilerFull, TextRow } from 'components';
import { PaginationFillTable } from '../pagination';

export const AccordionFullTable = ({
    tableInfo,
    list,
    margin,
    listCount,
    onRowClick,
    defaultOpen,
    handleAccordion,
    getParams,
    savedParams,
    notShowDown,
    renderAccordionDetails,
    classNameWrapper,
    containerStyles,
    parentClick,
    detailPage,
    selectedList,
    selectAllList,
    height,
    minWidth = 1200,
    expandedIds,
    onExpandChange,
}) => {
    const globalStyle = useGlobalStyles();
    const [page, setPage] = useState(1);
    const navigate = useNavigate();
    const location = useLocation();
    const info = location?.state;
    const loader = FindLoad(tableInfo?.loadingType ? tableInfo.loadingType : '');
    const loadBody = FindLoad(tableInfo?.loadingBodyType ? tableInfo.loadingBodyType : '');
    const [listInfo, setListInfo] = useState(list);
    const [searched, setSearched] = useState({ name: '', text: '' });
    const [expanded, setExpanded] = React.useState(defaultOpen ? defaultOpen : false);

    useEffect(() => {
        if (defaultOpen || defaultOpen === 0) {
            setExpanded(defaultOpen);
        }
    }, [defaultOpen]);

    useEffect(() => {
        if (list && !searched?.value) {
            setListInfo(list);
        }
    }, [list]);

    useEffect(() => {
        if (info?.page && !getParams) {
            setPage(info?.page);
        }
    }, [info]);

    const changePage = (number) => {
        setPage(number);
        setSearched({ name: '', text: '' });

        if (getParams) {
            const _skip = getSkipCount(number, 50);
            const pushInfo = { ...info };
            pushInfo.page = number;
            pushInfo.skip = _skip;
            getParams(pushInfo);
        } else {
            SendPageSave(number, info, navigate);
        }
    };

    const isRowExpanded = (item, k) => (expandedIds ? expandedIds.has(item?.id) : expanded === k);

    const handleChange = (panel, item) => (event, isExpanded) => {
        if (expandedIds) {
            onExpandChange?.(item?.id, isExpanded);
            return;
        }
        setExpanded(isExpanded ? panel : false);
        if (handleAccordion) {
            handleAccordion(isExpanded ? panel : false, item);
        }
    };

    const heightClass =
        height === 'extraSmall'
            ? globalStyle.tableContainerExtraSmall
            : height === 'auto'
            ? globalStyle.tableContainerAutoHeight
            : height === 'small'
            ? globalStyle.tableContainerSmallHeight
            : height === 'medium'
            ? globalStyle.tableContainerMediumHeight
            : globalStyle.tableContainer;

    return (
        <div style={margin ? { margin: margin } : {}} className={`${globalStyle.tableWrapper} ${classNameWrapper}`}>
            <div>
                <div className={`accordion-horizontal-scroll ${heightClass}`} style={{ overflowY: 'auto', ...containerStyles }}>
                    <div
                        className="accordion-table-head-wrapper"
                        style={{ minWidth, position: 'sticky', top: 0, zIndex: 3, flexShrink: 0 }}
                    >
                        {tableInfo?.head?.map(
                            (i, j) =>
                                i && (
                                    <div className="accordion-table-head-row" key={j} style={{ width: i?.width }}>
                                        {i?.renderView ? (
                                            <div>{i?.renderView}</div>
                                        ) : (
                                            <SearchAndFilerFull
                                                setListInfo={setListInfo}
                                                list={list}
                                                item={i}
                                                page={page}
                                                searched={searched}
                                                setSearched={setSearched}
                                                getParams={getParams}
                                                savedParams={savedParams}
                                            />
                                        )}
                                        {/*<p><TextRow name={i?.title} fontWeight={600} /></p>*/}
                                    </div>
                                )
                        )}
                    </div>
                    {loader.length ? (
                        <div style={{ flex: 1, minHeight: 0, position: 'relative', minWidth }}>
                            <Loader styles={{ height: '100%' }} />
                        </div>
                    ) : listInfo?.length ? (
                        <div
                            className="accordion-table-body-wrapper"
                            style={{
                                minWidth,
                                flex: 1,
                                minHeight: 0,
                                height: 'auto',
                                maxHeight: 'none',
                                overflow: 'visible',
                            }}
                        >
                            {listInfo?.map((i, k) => (
                                <React.Fragment key={k}>
                                    <Accordion
                                        style={{ background: isRowExpanded(i, k) ? 'rgba(235, 242, 253, 0.50)' : 'white' }}
                                        className={`accordion-wrapper${selectAllList || selectedList?.includes(i?.id) ? ' selected' : ''}`}
                                        expanded={isRowExpanded(i, k)}
                                        onChange={handleChange(k, i)}
                                    >
                                        <AccordionSummary aria-controls="panel1a-content" id="panel1a-header">
                                            {tableInfo?.body(i, k)?.map(
                                                (value, k) =>
                                                    value && (
                                                        <div
                                                            onClick={(e) => {
                                                                if (window.getSelection().toString()) return;
                                                                if (value?.notClickable) {
                                                                    e.preventDefault();
                                                                    e.stopPropagation();
                                                                } else {
                                                                    parentClick && parentClick(e, i, value);
                                                                }
                                                            }}
                                                            key={k}
                                                            className="accordion-table-body-row"
                                                            style={value?.styles ? value?.styles : { width: value?.width }}
                                                        >
                                                            {detailPage && detailPage(i) ? (
                                                                <Link
                                                                    onClick={(e) => {
                                                                        if (
                                                                            value?.notClickable === true ||
                                                                            window.getSelection().toString()
                                                                        ) {
                                                                            e.preventDefault();
                                                                            e.stopPropagation();
                                                                        }
                                                                    }}
                                                                    to={detailPage(i)}
                                                                    style={{ all: 'unset', cursor: 'pointer', width: '100%' }}
                                                                >
                                                                    {value?.value}
                                                                </Link>
                                                            ) : (
                                                                value?.value
                                                            )}
                                                        </div>
                                                    )
                                            )}
                                            {!notShowDown && (
                                                <div className="accordion-up-down">
                                                    <img
                                                        className="down-up-icon"
                                                        style={isRowExpanded(i, k) ? { transform: 'rotate(-180deg)' } : {}}
                                                        src={Images.dropDown}
                                                        alt="icon"
                                                    />
                                                </div>
                                            )}
                                        </AccordionSummary>
                                        <AccordionDetails>
                                            <div className="accordion-details-wrapper">
                                                {renderAccordionDetails?.(i, isRowExpanded(i, k))}

                                                {tableInfo?.renderBodyHeaderAction && <div>{tableInfo.renderBodyHeaderAction(i)}</div>}

                                                {tableInfo?.renderAccordionRow && !!tableInfo?.renderAccordionRow(i)?.length && (
                                                    <div className="accordion-details-head-wrapper">
                                                        {tableInfo?.accordionHead?.map((head, k) => (
                                                            <div
                                                                className="accordion-details-head-row"
                                                                style={{ width: head?.width }}
                                                                key={k}
                                                            >
                                                                <TextRow name={head?.title} fontWeight={600} />
                                                            </div>
                                                        ))}
                                                    </div>
                                                )}

                                                {tableInfo?.accordionBody && (
                                                    <>
                                                        {loadBody.length ? (
                                                            <Loader styles={{ position: 'relative' }} height={'200px'} />
                                                        ) : tableInfo?.renderAccordionRow && tableInfo?.renderAccordionRow(i)?.length ? (
                                                            tableInfo?.renderAccordionRow(i)?.map((item, j) => (
                                                                <div
                                                                    className={
                                                                        tableInfo?.accordionBodyCustomClass
                                                                            ? tableInfo?.accordionBodyCustomClass
                                                                            : 'accordion-details-body-wrapper'
                                                                    }
                                                                    key={j}
                                                                >
                                                                    {tableInfo?.accordionBody(item, j, i)?.map((body, k) => (
                                                                        <div
                                                                            key={k}
                                                                            className="accordion-details-body-row"
                                                                            onClick={(e) => {
                                                                                if (body?.notClickable) {
                                                                                    e.preventDefault();
                                                                                    e.stopPropagation();
                                                                                } else {
                                                                                    onRowClick && onRowClick(item);
                                                                                }
                                                                            }}
                                                                            style={{
                                                                                width: body?.width,
                                                                                padding: body?.padding,
                                                                            }}
                                                                        >
                                                                            {body?.value}
                                                                        </div>
                                                                    ))}
                                                                </div>
                                                            ))
                                                        ) : (
                                                            tableInfo?.noDetailsText && (
                                                                <NoItemsYet
                                                                    text={tableInfo?.noDetailsText}
                                                                    containerStyles={{
                                                                        padding: '20px 0',
                                                                        position: 'relative',
                                                                    }}
                                                                />
                                                            )
                                                        )}
                                                    </>
                                                )}
                                            </div>
                                        </AccordionDetails>
                                    </Accordion>
                                </React.Fragment>
                            ))}
                        </div>
                    ) : (
                        <div style={{ flex: 1, minHeight: 0, position: 'relative' }}>
                            <NoItemsYet
                                text={tableInfo?.notYet?.title}
                                subTitle={tableInfo?.notYet?.subTitle}
                                image={tableInfo?.notYet?.image}
                                containerStyles={{ height: '100%' }}
                            />
                        </div>
                    )}
                </div>
                {listCount > 0 && (
                    <div style={{ height: '76px' }}>
                        <PaginationFillTable
                            listLength={listInfo?.length}
                            page={page}
                            handleReturn={(number) => changePage(number)}
                            count={listCount}
                        />
                    </div>
                )}
            </div>
        </div>
    );
};
